import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        headerCell: {
            "& th": {
                background: theme.palette.primary.dark,
                color: theme.palette.primary.contrastText,
                fontWeight: "bold",
                "& span": {
                    color: "inherit",
                    "&:hover": {
                        color: "inherit"
                    }
                },
                "& .Mui-active": {
                    color: theme.palette.primary.contrastText,
                },
                "& .MuiTableSortLabel-icon": {
                    color: theme.palette.primary.contrastText,
                }
            }
        },
        tableBody: {
            '& tr:nth-of-type(even)': {
                backgroundColor: theme.palette.grey[100],
            },
            '& tr:nth-of-type(odd)': {
                backgroundColor: theme.palette.common.white,
            },
            "& .MuiTableCell-root": {
                padding: "8px 16px"
            }
        }
    };
});
